export default "__VITE_ASSET__CElzwxIr__"